(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@wallaby-ui/merie", [], factory);
	else if(typeof exports === 'object')
		exports["@wallaby-ui/merie"] = factory();
	else
		root["@wallaby-ui/merie"] = factory();
})(self, function() {
return 